import { Link } from "react-router-dom";

const LOGO_URL = "/smart-logo.jpeg";

export default function Footer() {
    return (
        <footer className="mt-32 border-t border-white/5" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
                <div className="col-span-2">
                    <div className="flex items-center gap-3 mb-4">
                        <img src={LOGO_URL} alt="SMART" className="h-12 w-12 object-contain" />
                        <span className="font-serif text-xl tracking-[0.15em]">SMART</span>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-sm leading-relaxed italic">
                        Your demands, 24/7. Anytime, Anywhere.
                    </p>
                    <p className="mt-3 text-xs text-muted-foreground max-w-sm leading-relaxed">
                        Jamaica's premier on-demand concierge — cleaning, glam, childcare, chef, grocery, transport and more.
                    </p>
                </div>

                <div>
                    <div className="overline mb-4">Service Cities</div>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li>Kingston</li>
                        <li>Montego Bay</li>
                        <li>Ocho Rios</li>
                        <li>Mandeville</li>
                        <li>Portmore</li>
                    </ul>
                </div>

                <div>
                    <div className="overline mb-4">Company</div>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li><Link to="/services" className="hover:text-foreground transition-colors" data-testid="footer-link-services">Services</Link></li>
                        <li><Link to="/vip" className="hover:text-foreground transition-colors" data-testid="footer-link-vip">VIP</Link></li>
                        <li><Link to="/become-provider" className="hover:text-foreground transition-colors" data-testid="footer-link-pro">Join as Pro</Link></li>
                        <li><Link to="/wheels/apply" className="hover:text-foreground transition-colors" data-testid="footer-link-drive">Drive with Wheels</Link></li>
                        <li><Link to="/shipping" className="hover:text-foreground transition-colors" data-testid="footer-link-shipping">Shipping &amp; Logistics</Link></li>
                        <li>
                            <a
                                href="https://knight-hire.preview.emergentagent.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-foreground transition-colors"
                                data-testid="footer-link-royal-ai"
                            >
                                SMART Royal AI
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className="overline mb-4">Policies</div>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                        <li><Link to="/about" className="hover:text-foreground transition-colors" data-testid="footer-link-about">About SMART</Link></li>
                        <li><Link to="/refund-policy" className="hover:text-foreground transition-colors" data-testid="footer-link-refund">Refund Policy</Link></li>
                        <li><Link to="/privacy-policy" className="hover:text-foreground transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-xs text-muted-foreground flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div>
                        <div data-testid="footer-legal-name">© {new Date().getFullYear()} SMART DEMANDS 24/7 LIMITED. All rights reserved.</div>
                        <div className="text-[10px] opacity-70 mt-0.5">A company duly incorporated under the Laws of Jamaica.</div>
                    </div>
                    <div className="overline">Verified · Insured · Background-Checked</div>
                </div>
            </div>
        </footer>
    );
}
